module.exports = __webpack_public_path__ + "static/media/error-404-dark.a504a224.jpg";